import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./i18n.resources";
import { SUPPORTED_LOCALES } from "./lib/locales";

export async function initClientI18n(locale: string): Promise<void> {
  await i18next.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LOCALES],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export default i18next;
